export const GET_DOWNLOAD_STATUS_DETAIL_LIST_REQUEST = 'GET_DOWNLOAD_STATUS_DETAIL_LIST_REQUEST'
export const GET_DOWNLOAD_STATUS_DETAIL_LIST_SUCCESS = 'GET_DOWNLOAD_STATUS_DETAIL_LIST_SUCCESS'
export const GET_DOWNLOAD_STATUS_DETAIL_LIST_FAILED = 'GET_DOWNLOAD_STATUS_DETAIL_LIST_FAILED'
export const CLEAR_DOWNLOAD_STATUS_DETAIL = 'CLEAR_DOWNLOAD_STATUS_DETAIL'
